import React, { useState, useEffect } from "react";
import Ikona from "../img/notes_icon.svg";

const Notes = () => {
  const [archive, setArchive] = useState(false);
  // const [slide, setSlide] = useState(-100);
  console.log(`ARCHIVE ${archive}`);
  // console.log(`SLIDE ${slide}`);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState();

  const [modalDelete, setModalDelete] = useState(false);
  const [passKey, setPassKey] = useState();
  const [modalActive, setModalActive] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [change, setChange] = useState(0);

  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setChange((prevState) => prevState + 1);
    }, 5);
    if (change === 100) {
      return () => {
        clearInterval(intervalTwo);
      };
    }
  }, []);

  console.log(isDisabled);
  console.log(title);
  console.log({ ...content });
  console.log(localStorage);

  useEffect(() => {
    localStorage.setItem(title, content);
  }, [content]);

  const handleChangeArchive = () => {
    setArchive(!archive);
  };

  // useEffect(() => {
  //   if (archive === true) {
  //     const intervalId = setInterval(() => {
  //       setSlide((prevState) => prevState + 0.5);
  //       if (slide === -3.5) {
  //         return () => {
  //           clearInterval(intervalId);
  //         };
  //       }
  //     }, 100);
  //   }
  //   if (archive === false && slide !== -100) {
  //     const intervalId = setInterval(() => {
  //       setSlide((prevState) => prevState - 0.5);
  //       if (slide === -100) {
  //         return () => {
  //           clearInterval(intervalId);
  //         };
  //       }
  //     }, 100);
  //   }
  // }, [archive]);

  const handleTitle = (e) => {
    e.preventDefault();
    setTitle(e.target.value);
    if (title === "") {
      setIsDisabled(true);
    } else setIsDisabled(false);
  };

  const handleContent = (e) => {
    setContent(e.target.value);
  };

  const handleSave = () => {
    setModalActive(!modalActive);
  };

  const handleDelete = () => {
    setModalDelete(!modalDelete);
  };

  const handleSetData = () => {
    handleReset();
    handleSave();
  };

  const handleReset = () => {
    setTitle("");
    setContent("");
    setIsDisabled(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setModalActive(!modalActive);
  };

  const handleDeleteItem = () => {
    localStorage.removeItem(passKey);
    handleDelete();
    handleReset();
  };

  return (
    <>
      <form
        style={{ opacity: change / 100 }}
        onSubmit={handleSubmit}
        className="notes_container"
      >
        {/* =====   MODAL SAVE   ===== */}
        {modalActive && (
          <div
            style={{ display: modalActive ? "block" : "none" }}
            className="modal"
          >
            <div className="modal_body">
              <h4>Do you want to save file</h4>
              <h3>"{title}"?</h3>
              <div className="notes_buttons">
                <button onClick={handleSave} className="notes_button">
                  No
                </button>
                <button onClick={handleSetData} className="notes_button">
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====   MODAL DELETE   ===== */}
        {modalDelete && (
          <div
            style={{ display: modalDelete ? "block" : "none" }}
            className="modal"
          >
            <div className="modal_body">
              <h4>Do you want to delete file</h4>
              <h3>"{passKey}"?</h3>
              <div className="notes_buttons">
                <button onClick={handleDelete} className="notes_button">
                  No
                </button>
                <button onClick={handleDeleteItem} className="notes_button">
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====   TITLE   ===== */}
        <div className="title">
          <div className="notes_header">
            <img src={Ikona} alt="ikona notes"></img>

            {/* =====   TYTUL   ===== */}
            <input
              type="text"
              className="title"
              placeholder="Tytuł:"
              name="title"
              value={title}
              onChange={handleTitle}
            />
          </div>
        </div>

        {/* =====   TEXT FIELD   ===== */}
        <div className="text_field">
          <div className={archive ? "archive active" : "archive"}>
            {/* <div
            style={{
              transform: `translateX(${slide}%)`,
              display: archive ? "flex" : "none",
            }}
          > */}
            {/* =====   PLIKI   ===== */}
            <ul>
              {Object.keys(localStorage)
                .slice(0, localStorage.length - 1)
                .map((key, index) => {
                  return (
                    <div key={index}>
                      <li
                        onClick={() => {
                          setTitle(key);
                          setContent(localStorage.getItem(key));
                          setIsDisabled(false);
                          setPassKey(key);
                        }}
                      >
                        {key}
                      </li>
                      <button
                        disabled={isDisabled}
                        onClick={handleDelete}
                        type="button"
                        className="delete"
                      >
                        DELETE
                      </button>
                    </div>
                  );
                })}
            </ul>

            {/* ================================== */}
          </div>
          <textarea
            disabled={isDisabled}
            placeholder="..."
            name="text"
            value={content}
            onChange={handleContent}
          ></textarea>
        </div>
        <div className="notes_buttons">
          {/* =====   FILES   ===== */}
          <button
            type="button"
            onClick={handleChangeArchive}
            className="notes_button"
          >
            Files
          </button>

          {/* =====   RESET  ===== */}
          <button
            type="button"
            name={title}
            onClick={handleReset}
            className="notes_button"
          >
            Reset
          </button>

          {/* =====   SAVE   ===== */}
          <button
            type="submit"
            disabled={isDisabled}
            name={title}
            className="notes_button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </form>
    </>
  );
};

export default Notes;
